export default {"src":"/_next/static/media/step2.e4a554c4.svg","height":58,"width":58};